export default "__VITE_ASSET__ettFuPf8__"